import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";
import { TypographyScale } from "../../../Foundation/Typography/Typography.styles";

export const _LandingAboutRoot = styled("section")<{
  $bg?: {
    desktop?: string;
    mobile?: string;
  };
}>(
  ({ $bg }) => {
    const { desktop: desktopBg, mobile: mobileBg } = $bg || {};
    return css`
      background-image: url(${desktopBg});
      background-size: 100% auto;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 40px 48px;

      @media ${responsiveMap.mobile} {
        padding: 24px 16px;
        background-image: url(${mobileBg || desktopBg});
      }

      .landing-about__container {
        display: grid;
        grid-template-columns: repeat(2, 50%);
        grid-template-rows: 1fr;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        width: 100%;

        @media ${responsiveMap.mobile} {
          display: flex;
          flex-direction: column;
        }

        &.without-image {
          display: flex;
          flex-direction: column;
          & .landing-about__description__container {
            max-width: 664px;

            @media ${responsiveMap.mobile} {
              padding: 0px;
            }
          }
        }

        &.image-right {
          & .landing-about__left {
            grid-area: 1 / 2 / 2 / 3;
          }
          & .landing-about__right {
            grid-area: 1 / 1 / 2 / 2;
          }
        }

        & .landing-about__left {
          grid-area: 1 / 1 / 2 / 2;
        }
        & .landing-about__right {
          grid-area: 1 / 2 / 2 / 3;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .landing-about__description__container {
        width: 70%;
        max-width: 672px;
        margin: 0 auto;
        padding: 35px 24px 40px;
        @media ${responsiveMap.mobile} {
          width: 100%;
          padding: 24px 0px;
          padding-bottom: clac(24px - 9px);
        }
      }

      .landing-about__title {
        text-align: center;
        margin-bottom: 32px;
      }

      .landing-about__image {
        aspect-ratio: 1;
      }

      // .landing-about {
      //   // background-color: #ffffff;
      //   // color: #000000;

      //   &__image {
      //     position: relative;
      //     overflow: hidden;

      //     &__cover {
      //       // width: 100%;
      //       // height: 100%;
      //       // position: relative;
      //       // overflow: hidden;
      //       // padding-top: 83%;

      //       // @media #{$medium-width} {
      //       //   padding-top: 120%;
      //       // }

      //       // & > img {
      //       //   width: 100%;
      //       //   height: 100%;
      //       //   object-fit: cover;
      //       //   position: absolute;
      //       //   top: 0%;
      //       //   object-position: 100% 50%;
      //       // }
      //     }
      //   }

      //   &__title {
      //     text-align: center;
      //   }

      //   &__description {
      //     margin-top: 40px;
      //     @media #{$medium-width} {
      //       margin-top: 25px;
      //     }
      //     &__container {
      //       width: 100%;
      //       max-width: 438px;
      //       margin: 0 auto;
      //       padding: 35px 24px 40px;
      //     }
      //     text-align: left;
      //   }
      // }
    `;
  },
  () => {
    return {
      ".landing-about__description": {
        [`@media ${responsiveMap.mobile}`]: {
          ...TypographyScale.body2,
        },
      },
    };
  }
);
